<template>
    <div id="remember">

        <div class="box">
            <img class="logo" src="/img/logo_new.png">
            <div id="message_password" class="message" v-show="message">{{message}}</div>
            <div v-show="intime">
                <div class="subtitle">Introdueix la nova contrassenya</div>
                <input type="password" name="password1" v-model="input.password1" placeholder="Contrassenya" />
                <input type="password" name="password2" v-model="input.password2" placeholder="Repetir contrassenya" v-on:keyup.enter="changePassword()" />

                <button type="button" v-on:click="changePassword()">Canviar contrassenya</button>

                <router-link to="/login" class="login">Iniciar sesió</router-link>

                <div class="itw-logo"><a href="https://intowingroup.com/" target="_blank"><img src="/img/logo-intowin-grey1.png"/></a><span>Technological partner</span></div>
            </div>

        </div>

    </div>
</template>

<script>
    import {Api} from '@/core/api.js';
    const api = new Api();

    import i18n from '@/i18n'

    export default {
        name: 'ChangePassword',
        data() {
            return {
                input: {
                    password1: "",
                    password2: ""
                },
                message: false,
                intime: false
            }
        },
        mounted() {
            var timestamp = this.$route.params.limit;
            if( moment().valueOf() <= moment( timestamp * 1000 ).valueOf() ){
                this.intime = true;
            }
            else{
                this.message = i18n.t( 'login.link_expired')
                document.getElementById( 'message_password' ).classList.remove( 'success' );
                document.getElementById( 'message_password' ).classList.add( 'error' );
            }
        },
        methods: {
            changePassword() {
                var self = this;
                var password1 = sha256( this.input.password1 );
                var password2 = sha256( this.input.password2 );

                if( password1 != password2 ){
                    self.message = "Les contrassenyes no són idéntiques";
                    document.getElementById( 'message_password' ).classList.remove( 'success' );
                    document.getElementById( 'message_password' ).classList.add( 'error' );
                }
                else {
                    api.post( 'changepassword', { id: this.$route.params.id, password: password1 } ).then( function( response ){
                        if( response.status ) {
                            self.message = "Contrassenya modificada amb éxit";
                            document.getElementById( 'message_password' ).classList.remove( 'error' );
                            document.getElementById( 'message_password' ).classList.add( 'success' );
                            // self.$destroy();
                        } else {
                            self.message = "No s'ha pogut modificar la contrassenya";
                            document.getElementById( 'message_password' ).classList.remove( 'success' );
                            document.getElementById( 'message_password' ).classList.add( 'error' );
                        }
                    });
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    
    #remember {
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        margin: 0;
        padding: 25px;
        background: $dark-color;

        .box {
            max-width: 275px;
            width: 100%;
            margin: 0 auto;

            width: 80%;
            height: 80%;
            overflow: auto;
            margin: auto;
            position: absolute;
            top: 0; left: 0; bottom: 0; right: 0;
            text-align: center;

            .logo {
                width: 100%;
                margin-bottom: 50px;
            }
            .title {
                color: $secondary-color;
                font-size: 24px !important;
                line-height: 24px !important;
                position: relative;
                width: 100%;
                margin: 0 0 30px 0;
            }
            .subtitle {
                color: $secondary-color;
                font-size: 16px !important;
                line-height: 24px !important;
                position: relative;
                width: 100%;
                margin: 0 0 30px 0;
            }

            .message {
                text-align: center;
                font-size: 18px;
                margin: 0 0 15px 0;
                padding: 5px 0;

                &.error {
                    border: 1px solid #c10c0c;
                    border-radius: 5px;
                    background-color: #e88383;
                    color: #FFF;
                }
                &.success {
                    border: 2px solid #087908;
                    border-radius: 5px;
                    background-color: #a0f8b6;
                    color: #000;
                }
            }

            input{
                width: 100%;
                padding: 15px;
                margin-bottom: 5px;
                border: 1px solid $secondary-color;
                outline: none;
                font-size: 11pt;
                border-radius: 3px;
                color: $secondary-color;
                //background: #ddd;
                //border: none;
                //border-left: 35px solid var(--main-color);
                //border-right: 35px solid var(--main-color);

                &:focus {
                    border: 1px solid $first-color;
                }

            }
            button {
                width: 100%;
                padding: 15px;
                outline: none;
                border: none;
                cursor: pointer;
                font-size: 12pt;
                font-family: Speedee-Bold;
                margin-top: 5px;
                border-radius: 3px;
                text-transform: uppercase;
                transition: all 0.5s;
                background: $secondary-color;
                color: $main-color;

                &:hover {
                    background: $first-color;
                    color: #fff;
                }
            }

            .login {
                font-size: 10pt;
                margin-top: 20px;
                color: #888;
                cursor: pointer;
                display: block;
                text-decoration: none;

                &:hover {
                    text-decoration: underline;
                }
            }

            .itw-logo {
                width: 320px;
                margin: 0 auto;
                margin-top: 25px;
                display: block;
                position: fixed;
                bottom: 15%;
                left: 50%;
                margin-left: -160px;
                display: flex;
                align-items:center;

                img {
                    width: 160px;
                }
                span {
                    color: #888;
                    font-size: 14px;
                    margin-left: 10px;
                }
            }

        }
    }

</style>